import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import NotFoundPage from '../../common/pages/NotFoundPage';
import RegionsPage from '../pages/RegionsPage';
import CreateRegionPage from '../pages/CreateRegionPage';
import routes from '../../common/models/route-constants';

function IllustrationRegionsRouter({ user }) {
    let { path } = useRouteMatch();
    return (
        <React.Fragment>
            <Switch>
                <Route exact path={`${path}`}>
                    <RegionsPage />
                </Route>
                <Route exact path={`${path}/${routes.CREATE}`}>
                    <CreateRegionPage />
                </Route>
                <Route path='*'>
                    <NotFoundPage />
                </Route>
            </Switch>
        </React.Fragment>
    );
}

export default IllustrationRegionsRouter;
